import type { ActionFunctionArgs } from "react-router";
import { useActionData, Form, Link } from "react-router";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Button } from "~/components/shared/Button";
import { InputField } from "~/components/shared/Form";
import { resetPasswordRequest } from "~/session.server";

export const action = async ({ request }: ActionFunctionArgs) => {
  if (request.method === "POST") {
    const formData = await request.formData();
    const email = formData.get("email") as string;
    try {
      const result = await resetPasswordRequest(email);
      if (result.message) {
        return result.message;
      }
      return result.errors;
    } catch (errors) {
      return { errors, email };
    }
  }
};

export function meta() {
  return [
    {
      title: "Forgot Password - Jiwe eSports",
    },
  ];
}

export default function ForgotPasswordRoute() {
  const resetError = useActionData<string>();

  useEffect(() => {
    if (resetError && !resetError.includes("Check email")) {
      toast.error(resetError);
    } else {
      toast.info(resetError);
    }
  }, [resetError]);

  return (
    <div className="flex flex-col-reverse sm:flex-row sm:justify-center sm:items-center sm:content-center mt-[8rem]">
      <div className="mx-[10%]">
        <div className="flex flex-col items-center mb-12 pb-6 border-b-[.5px] border-b-divider dark:border-b-divider-dark">
          <img src="/assets/logo.png" alt="logo" className="h-[4rem] mb-5" />
          <h1 className="font-bold text-xl text-center text-grey-border uppercase ml-[1rem]">
            Reset your <br />
            <span className="text-jiwe-blue dark:text-jiwe-red">
              Jiwe esports
            </span>
            <br />
            account password
          </h1>
        </div>
        <Form method="post">
          <InputField type="email" name="email" label="Email" required />
          <Button
            type="submit"
            className="bg-jiwe-yellow uppercase w-full mb-8"
          >
            Reset Password
          </Button>
          <div className="flex flex-col lg:flex-row gap-y-4 items-center font-bold text-jiwe-red dark:text-jiwe-blue">
            <Link to="/login">I remember my password</Link>
          </div>
        </Form>
      </div>
    </div>
  );
}
